import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

export default function HowItWorksSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const steps = [ 'Kontakt', 'Procena', 'Selidba', 'Useljenje' ];

  return (
    <section ref={ref} style={{ padding: '40px 0' }}>
      <svg width="100%" height="120" viewBox="0 0 800 120">
        <motion.path
          d="M 50 60 L 750 60"
          stroke="#0ea5e9"
          strokeWidth="4"
          fill="none"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: isInView ? 1 : 0 }}
          transition={{ duration: 1.2, ease: 'easeInOut' }}
        />
      </svg>
      <div style={{ display: 'grid', gridTemplateColumns:`repeat(${steps.length}, 1fr)`, gap: 16 }}>
        {steps.map((s, i) => (
          <motion.div key={s} initial={{ opacity: 0, y: 20 }} animate={{ opacity: isInView ? 1 : 0, y: isInView ? 0 : 20 }} transition={{ delay: 0.2 + i*0.2 }} style={{ textAlign:'center' }}>
            <div style={{ width: 56, height: 56, borderRadius: '50%', background:'#0ea5e9', margin:'-88px auto 8px' }} />
            <h4>{s}</h4>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
